import type { MGTFaultReportDocument } from "../types";
import { createStringColumn } from "./columnHelpers";

const namespace = "mgt_fault_reports";

export const mgtFaultReportsColumns = [
    createStringColumn<MGTFaultReportDocument>({
        namespace,
        field: "faultreport",
        header: "Fault Report",
    }),
    createStringColumn<MGTFaultReportDocument>({
        namespace,
        field: "bNumber",
        header: "Machine Number",
    }),
    createStringColumn<MGTFaultReportDocument>({
        namespace,
        field: "machineType",
        header: "Product Type",
    }),
    createStringColumn<MGTFaultReportDocument>({
        namespace,
        field: "catchword",
        header: "Catchword",
    }),
];
